module.exports = __webpack_public_path__ + "img/source05_6.be91e0e1.png";